import { render } from "./index.vue?vue&type=template&id=62625522"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=62625522&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseUi/FormPhoneSelect/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62625522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62625522', __exports__)) {
    api.reload('62625522', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=62625522", () => {
    api.rerender('62625522', render)
  })

}


export default __exports__